import Home from '../components/pages/home/Home'
import NotFound from '../components/pages/404/NotFound'
import Login from '../components/pages/login/Login'
import Recover from '../components/pages/forgotpassword/Recover'
import Reset from '../components/pages/forgotpassword/Reset'
import Register from '../components/pages/register/Register'
import UpdatePass from '../components/pages/updatepass/UpdatePass'
import Profile from '../components/pages/profile/Profile'
import ServerConfig from '../components/pages/admin/server-config/ServerConfig'
// import FileProcesses from '../components/pages/fileprocesses/FileProcesses';
// import SourceInventory from '../components/pages/reports/SourceInventory'
// import PartsInventory from '../components/pages/reports/PartsInventory'
// import ReceivingReport from '../components/pages/reports/ReceivingReport'
// import SaleOrdersAssetDetail from '../components/pages/reports/SaleOrdersAssetDetail'
// import SaleOrdersByStatus from '../components/pages/reports/SaleOrdersByStatus'
// import Jobs from '../components/pages/jobs/Jobs'
import LeadGenLanding from '../components/pages/leadgen/LeadGenLanding'
import AdminHome from '../components/pages/admin/AdminHome'
import AdminUsers from '../components/pages/admin/users/AdminUsers'
import AdminOrganizations from '../components/pages/admin/organizations/AdminOrganizations'
import AdminLeads from '../components/pages/admin/leads/AdminLeads'
import AdminOrgLeads from '../components/pages/admin/leads/AdminOrgLeads'
import AdminRequests from '../components/pages/admin/requests/AdminRequests';
import Leads from '../components/pages/admin/leads/Leads';
import Dashboard from '../components/pages/admin/reports/Dashboard'
import SetterLeads from '../components/pages/admin/leads/SetterLeads'
import MyCommissions from '../components/pages/reports/MyCommissions';
import MeDashboard from '../components/pages/admin/reports/MeDashboard';
import LeadsManager from '../components/pages/admin/leads/LeadsManager';
import MyCalendar from '../components/pages/reports/MyCalendar'
import Calendar from '../components/pages/reports/Calendar'
import AdminLearning from '../components/pages/admin/learning/AdminLearning';
import LearningCenter from '../components/pages/learning/LearningCenter';
import LearningVideo from '../components/pages/learning/LearningVideo';

const routes = [
    {
      id: 'login',
      name: 'login',
      path: '/login',
      exact: true,
      protected: false,
      component: Login,
    },
    {
      id: 'recover',
      name: 'recover',
      path: '/recover',
      exact: true,
      protected: false,
      component: Recover,
    },
    {
      id: 'reset',
      name: 'reset',
      path: '/reset/:id/:token',
      exact: true,
      protected: false,
      component: Reset,
    },
    {
      id: 'register',
      name: 'register',
      path: '/register',
      exact: true,
      protected: false,
      component: Register,
    },
    {
      id: 'home',
      name: 'home',
      path: '/',
      exact: true,
      protected: false,
      component: Home,
    },
    {
      id: 'leadgen',
      name: 'leadgen',
      path: '/lg/:orgReferralCode?',
      exact: true,
      protected: false,
      component: LeadGenLanding,
    },
    {
      id: 'me_dashboard',
      name: 'me_dashboard',
      path: '/dashboard/me',
      exact: true,
      protected: false,
      component: MeDashboard,
    },
    {
      id: 'dashboard',
      name: 'dashboard',
      path: '/dashboard/:orgReferralCode?',
      exact: true,
      protected: false,
      component: Dashboard,
    },
    {
      id: 'leads_manager',
      name: 'leads_manager',
      path: '/leads/unassigned',
      exact: true,
      protected: false,
      component: LeadsManager,
    },
    {
      id: 'profile',
      name: 'profile',
      path: '/profile',
      exact: true,
      protected: false,
      component: Profile,
    },
    // {
    //   id: 'serverconfig',
    //   name: 'serverconfig',
    //   path: '/serverconfig',
    //   exact: true,
    //   protected: false,
    //   component: ServerConfig,
    // },
    {
      id: 'updatepass',
      name: 'updatepass',
      path: '/updatepass',
      exact: true,
      protected: false,
      component: UpdatePass,
    },
    {
      id: 'AdminHome',
      name: 'AdminHome',
      path: '/admin/home',
      exact: true,
      protected: false,
      component: AdminHome,
    },
    {
      id: 'AdminHome',
      name: 'AdminHome',
      path: '/admin',
      exact: true,
      protected: false,
      component: AdminHome,
    },
    {
      id: 'AdminUsers',
      name: 'AdminUsers',
      path: '/admin/users',
      exact: true,
      protected: false,
      component: AdminUsers,
    },
    {
      id: 'AdminOrganizations',
      name: 'AdminOrganizations',
      path: '/admin/organizations',
      exact: true,
      protected: false,
      component: AdminOrganizations,
    },
    {
      id: 'AdminLead',
      name: 'AdminLead',
      path: '/admin/leads',
      exact: true,
      protected: false,
      component: AdminLeads,
    },
    {
      id: 'AdminLead',
      name: 'AdminLead',
      path: '/admin/leads/:orgReferralCode',
      exact: true,
      protected: false,
      component: AdminOrgLeads,
    },
    {
      id: 'AdminLearning',
      name: 'AdminLearning',
      path: '/admin/learning',
      exact: true,
      protected: false,
      component: AdminLearning,
    },
    {
      id: 'Leads',
      name: 'Leads',
      path: '/leads',
      exact: true,
      protected: false,
      component: Leads,
    },
    {
      id: 'MyCommissions',
      name: 'MyCommissions',
      path: '/my/commissions',
      exact: true,
      protected: false,
      component: MyCommissions,
    },
    {
      id: 'MyAppointments',
      name: 'MyAppointments',
      path: '/my/calendar',
      exact: true,
      protected: false,
      component: MyCalendar,
    },
    {
      id: 'Appointments',
      name: 'Appointments',
      path: '/calendar/:orgReferralCode?',
      exact: true,
      protected: false,
      component: Calendar,
    },
    {
      id: 'SetterLeads',
      name: 'SetterLeads',
      path: '/setter/leads',
      exact: true,
      protected: false,
      component: SetterLeads,
    },
    {
      id: 'AdminRequests',
      name: 'AdminRequests',
      path: '/admin/requests',
      exact: true,
      protected: false,
      component: AdminRequests,
    },
    {
      id: 'learningcenter',
      name: 'learningcenter',
      path: '/learning',
      exact: true,
      protected: false,
      component: LearningCenter,
    },
    {
      id: 'learningvideo',
      name: 'learningvideo',
      path: '/learning/video/:videoId',
      exact: true,
      protected: false,
      component: LearningVideo,
    },
    /* Error route */
    {
      id: '404',
      name: 'Not Found',
      path: '*',
      exact: true,
      protected: false,
      component: NotFound,
    },
]; 

export default routes;
